/**
 * Paddle rejected the seller account on 18 Sep 2026 (Acceptable Use Policy),
 * so the card rail was removed from the UI; the Paddle modules and webhook
 * stay in place, dormant, only for historical data.
 *
 * How buyers OUTSIDE Syria pay: PayPal only (manual receipt rail).
 * Inside Syria: Sham Cash / Al-Haram transfer.
 */
export type OutsideSyriaRail = "paypal" | "paddle";

/** Consultations, digital products and courses all use PayPal. */
export const CONSULTATION_RAIL: OutsideSyriaRail = "paypal";

/** Default rail for every outside-Syria purchase. */
export const OUTSIDE_SYRIA_RAIL: OutsideSyriaRail = CONSULTATION_RAIL;

/** Label for the "outside Syria" country toggle on the checkout pages. */
export const OUTSIDE_SYRIA_TOGGLE_LABEL_AR = "من خارج سوريا (PayPal)";

export const PAYPAL_ACCOUNT_EMAIL = "Saraalnahas521188@gmail.com";
export const PAYPAL_ME_HANDLE = "SaraAlnahas";

/** payment_instructions.region_slug holding the PayPal instructions. */
export const PAYPAL_INSTRUCTIONS_REGION = "paypal_outside_syria";

/** purchases.payment_method value for an approved PayPal transfer. */
export const PAYPAL_PAYMENT_METHOD = "paypal";
/** purchases.payment_method value for an approved inside-Syria transfer. */
export const LOCAL_TRANSFER_PAYMENT_METHOD = "bank_transfer_sy";

export function isPaypalRail(rail: OutsideSyriaRail = OUTSIDE_SYRIA_RAIL): boolean {
  return rail === "paypal";
}

/** `https://paypal.me/SaraAlnahas/15USD` — Latin digits, no trailing zeros. */
export function paypalPayUrl(amountUsd: number | string): string {
  const n = Number(amountUsd);
  const amount = Number.isFinite(n) && n > 0 ? (Number.isInteger(n) ? String(n) : n.toFixed(2)) : "0";
  return `https://paypal.me/${PAYPAL_ME_HANDLE}/${amount}USD`;
}

/**
 * Country stored on a PayPal pending_purchases row. It decides the payment
 * method at approval time, so it must never be "SY" on this rail even if the
 * buyer picked a Syrian WhatsApp dial code.
 */
export function outsideSyriaCountry(dialCountry: string | null | undefined): string {
  const code = (dialCountry ?? "").trim().toUpperCase();
  if (!code || code === "SY") return "XX";
  return code;
}

/** Approval maps the pending row's country onto the purchase payment method. */
export function purchasePaymentMethodForCountry(country: string | null | undefined): string {
  const code = (country ?? "").trim().toUpperCase();
  return code && code !== "SY" ? PAYPAL_PAYMENT_METHOD : LOCAL_TRANSFER_PAYMENT_METHOD;
}
